import type { Study } from '@pocketprep/types'

type TLicenseState = {
    licenses: Study.Class.LicenseJSON[]
}

export const getInitialLicenseState = (): TLicenseState => {
    return {
        licenses: [],
    }
}

const moduleState = getInitialLicenseState()

export default moduleState
